import { For, Show, createEffect, createSignal, onCleanup } from "solid-js";
import type { PlaySettings } from "../game/auto";
import { t } from "../strings";
import { TileGuide } from "./TileGuide";
import { Dialog } from "./Dialog";

const AIDS = ["auto_win", "skip_calls", "tsumogiri", "auto_sort", "sound"] as const;

// The table's own aids, each saying what it does. On a phone they wait behind one button: two lines of them under the hand took the room from the hand,
// and in the way of a thumb (review 2026-11-01).
export function Aids(props: { settings: PlaySettings; onSettings: (s: PlaySettings) => void; hidden?: boolean }) {
  const [open, setOpen] = createSignal(false);
  const [guide, setGuide] = createSignal(false);
  let root!: HTMLDivElement;
  createEffect(() => {
    if (!open()) return;
    const outside = (e: PointerEvent) => {
      if (e.target instanceof Node && !root.contains(e.target)) setOpen(false);
    };
    addEventListener("pointerdown", outside, true); // first: the table keeps some of its presses to itself
    onCleanup(() => removeEventListener("pointerdown", outside, true));
  });
  return (
    <div class={`aids${open() ? " open" : ""}`} hidden={props.hidden} ref={root}>
      <button type="button" class="secondary aids-button" aria-expanded={open()} onClick={() => setOpen(!open())}>
        {t.aids}
      </button>
      <div class="aids-toggles" role="group" aria-label={t.aids}>
        <For each={AIDS}>
          {(k) => (
            <label title={t.aidHelp[k]}>
              <input type="checkbox" checked={props.settings[k]} onChange={(e) => props.onSettings({ ...props.settings, [k]: e.currentTarget.checked })} />
              <span>
                {t.aidNames[k]}
                <small>{t.aidHelp[k]}</small>
              </span>
            </label>
          )}
        </For>
        {/* Looking a tile up used to mean leaving the table, with its clock running. */}
        <button type="button" class="link aids-guide" onClick={() => setGuide(true)}>
          {t.tileGuide.title}
        </button>
      </div>
      <Show when={guide()}>
        <Dialog label={t.tileGuide.title} class="guide-dialog" onClose={() => setGuide(false)}>
            <h2>{t.tileGuide.title}</h2>
            <TileGuide />
            <button type="button" onClick={() => setGuide(false)}>
              {t.hints.close}
            </button>
        </Dialog>
      </Show>
    </div>
  );
}
